import { render, staticRenderFns } from "./viewList.vue?vue&type=template&id=db50f884&scoped=true&"
import script from "./viewList.vue?vue&type=script&lang=js&"
export * from "./viewList.vue?vue&type=script&lang=js&"
import style0 from "./viewList.vue?vue&type=style&index=0&id=db50f884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db50f884",
  null
  
)

export default component.exports